import { render, staticRenderFns } from "./UsuarioTipos.vue?vue&type=template&id=5cad07dc"
import script from "./UsuarioTipos.vue?vue&type=script&lang=js"
export * from "./UsuarioTipos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports